import { colors } from "@mui/material";

export const redGreenSelector = (colorChange: boolean) =>
  colorChange ? colors.green[400] : colors.red[700];
